theme.Contact = (function() {
  function Contact(container) {     
    var sectionId = container.getAttribute('data-section-id');
    var hny = document.getElementById('honeypot');
        hny.innerHTML = '<button class="btn standard-width bottompad" type="submit" id="contactFormSubmit">' + theme.language.contact_form_send + '<span class="rt-secondary-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>';
    document.getElementById('contactFormSubmit').onclick = function(ev){
      if (document.getElementById('contactFormNumber').value.length > 0) {
        ev.preventDefault();
      }
    }
  }
  return Contact;
})();